var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import Tracker from "./src/Tracker";
// Esempio di utilizzo
window.Tracker = window.Tracker || {};
window.Tracker.events = window.Tracker.events || [];
// Consent purposes queued via the install snippet's `Tracker.consent.
// setConsent(...)` stub (see docs.vue) before this script had loaded and
// replaced `Tracker.consent` with the real ConsentManager.
var consentQueue = ((_a = window.Tracker.consent) === null || _a === void 0 ? void 0 : _a.queue) || [];
var tracker = new Tracker(window.Tracker.client, window.Tracker.instance);
window.Tracker.events.forEach(function (evt) { return tracker.send.apply(tracker, __spreadArray([evt[0]], evt.slice(1), false)); });
consentQueue.forEach(function (purposes) { return tracker.consent.setConsent(purposes); });
window.Tracker = tracker;
